import { connect } from 'react-redux';
import { State } from '../reducers/index';
import { GenericThunkDispatch } from '../types/Types';
import { createLoadingSelector } from '../utils/selectors';
import { POST_OTP_BASE, clearMessage } from '../actions/login';
import { postOtp } from '../middleware/loginActions';
import TwoFactorAuthForm from '../components/TwoFactorAuthForm';

const loadingSelector = createLoadingSelector([POST_OTP_BASE]);

const mapStateToProps = (state: State) => ({
    loading: loadingSelector(state),
    errorMessage: state.login.message ? state.login.message.text : null,
    isSubmitted: state.login.isSubmitted
});

const mapDispatchToProps = (dispatch: GenericThunkDispatch) => ({
    verifyOtp: (otpCode: string) => {
        dispatch(postOtp(otpCode));
    },
    onClearMessage: () => {
        dispatch(clearMessage());
    }
});

export default connect(mapStateToProps, mapDispatchToProps)(TwoFactorAuthForm);
